/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savesettings1Inputs */

const vi_savesettings1 = /** @type {(inputs: Savesettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu cài đặt`)
};

/**

* @param {Savesettings1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const savesettings1 = /** @type {((inputs?: Savesettings1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savesettings1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_savesettings1(inputs)
});
export { savesettings1 as "saveSettings" }